import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { KalDialogRef, KalSnackbarService } from '@kalidea/kaligraphi';
import gql from 'graphql-tag';
import { catchError, tap, throwError } from 'rxjs';
import { GraphqlService } from 'src/app/_core/services/graphql.service';
import { BaseComponent } from 'src/app/_core/tools/base.component';
import { FormValidator } from 'src/app/validators/form-validator';
import { MutationSaveListePaysArgs, StatusDtoEnum } from 'src/graphql/generated-types';

type SharedAddCountryFormType = {
    countryName: FormControl<string | null>;
    countryCode: FormControl<string | null>;
}

export class SharedAddCountryDialogData {
    accepted?: boolean;
}

@Component({
    selector: 'app-shared-add-country-dialog',
    templateUrl: './shared-add-country-dialog.component.html',
    styleUrls: ['./shared-add-new-country-dialog.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SharedAddCountryDialogComponent extends BaseComponent implements OnInit {

    form: FormGroup<SharedAddCountryFormType>;

    constructor(protected readonly cdr: ChangeDetectorRef,
                private dialogRef: KalDialogRef<SharedAddCountryDialogComponent>,
                private graphqlService: GraphqlService,
                private readonly snackbarService: KalSnackbarService,
                private readonly fb: FormBuilder) {
        super(cdr);
    }

    saveCountry(): void {
        if (this.form.invalid) {
            return;
        }

        this.loading = true;
        this.watch$ = this.graphqlService.mutateOne<'SaveListePays', MutationSaveListePaysArgs>({
            mutation: gql`
                mutation SaveListePays($contexte: ContextInfosInput, $pays: ArrayOfPaysDTOInput) {
                    SaveListePays(contexte: $contexte, pays: $pays) {
                        PaysDTO {
                            Id
                            Libelle
                        }
                    }
                }
          `,
            variables: {
                pays: {
                    PaysDTO: [{
                        Libelle: this.form.value.countryName || '',
                        Code: this.form.value.countryCode || '',
                        Status: StatusDtoEnum.Inserted
                    }]
                }
            }
        }).pipe(
            tap((response) => {
                this.snackbarService.open({title: `Le pays ${response.PaysDTO[0].Libelle} a été ajouté.`});
                this.loading = false;
                this.dialogRef.close();
            }),
            catchError(err => {
                this.snackbarService.open({title: 'Une erreur est survenue lors de l\'ajout du pays.'});
                this.loading = false;
                return throwError(() => err);
            })
        );
    }

    submit(): void {
        this.saveCountry();
    }

    cancel(): void {
        this.dialogRef.close();
    }

    ngOnInit(): void {
        this.form = this.fb.group({
            countryName: [null, [FormValidator.isNotNull]],
            countryCode: [null, [FormValidator.isNotNull]]
        }) as FormGroup<SharedAddCountryFormType>;
    }
}
